var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-no-image.4040d73b.png","uri@2x": __webpack_public_path__ + "icon-no-image.664f0db9.png","uri@3x": __webpack_public_path__ + "icon-no-image.3f7ee7e3.png",
    width: 55,
    height: 55
});